import React from "react";
import { Link } from "react-router-dom";

import luminousOrbit from "../../images/luminous-intelligence-orbit.webp";
import arrowRightIcon from "../../images/icon-arrow-right.svg";
import unityLearningIcon from "../../images/icon-unity-learning.svg";
import talentLenzIcon from "../../images/icon-talentlenz.svg";
import fleetCoreIcon from "../../images/icon-fleetcore.svg";
import workPassportIcon from "../../images/icon-work-passport.svg";

import "./HeroSection.css";

const products = [
  {
    name: "Unity Learning",
    destination: "/unity-learning",
    tone: "blue",
    icon: unityLearningIcon,
  },
  {
    name: "TalentLenz",
    destination: "/talentlenz",
    tone: "pink",
    icon: talentLenzIcon,
  },
  {
    name: "FleetCore",
    destination: "/fleet-core",
    tone: "blue",
    icon: fleetCoreIcon,
  },
  {
    name: "Work Passport",
    destination: "/workpassport",
    tone: "pink",
    icon: workPassportIcon,
  },
];

function FloatingProductCard({ product, index }) {
  const { name, tone, icon } = product;

  return (
    <div
      className={`andus-hero__orbit-track andus-hero__orbit-track--${
        index + 1
      }`}
      aria-hidden="true"
    >
      <div
        className={`andus-hero__floating-card andus-hero__floating-card--${tone}`}
      >
        <span className="andus-hero__floating-icon">
          <img src={icon} alt="" />
        </span>

        <span className="andus-hero__floating-content">
          <strong>{name}</strong>

          <span className="andus-hero__floating-line andus-hero__floating-line--long" />
          <span className="andus-hero__floating-line andus-hero__floating-line--short" />
        </span>

        <span className="andus-hero__floating-dots">
          <i />
          <i />
          <i />
        </span>
      </div>
    </div>
  );
}

function ProductNavigationCard({ product }) {
  const { name, destination, tone, icon } = product;

  return (
    <Link
      className={`andus-hero__product-link andus-hero__product-link--${tone}`}
      to={destination}
      aria-label={`Explore ${name}`}
    >
      <span className="andus-hero__product-icon">
        <img src={icon} alt="" aria-hidden="true" />
      </span>

      <span className="andus-hero__product-name">{name}</span>

      <img
        className="andus-hero__product-arrow"
        src={arrowRightIcon}
        alt=""
        aria-hidden="true"
      />
    </Link>
  );
}

export default function HeroSection() {
  return (
    <section className="andus-hero" aria-labelledby="andus-hero-title">
      <div className="andus-hero__inner">
        <div className="andus-hero__main">
          <div className="andus-hero__copy">
            <p className="andus-hero__eyebrow">
              Applied Intelligence Systems
            </p>

            <h1 id="andus-hero-title" className="andus-hero__title">
              Intelligence,
              <br />
              applied to
              <br />
              real work.
            </h1>

            <p className="andus-hero__body">
              Choose a ready-to-deploy platform: Unity Learning for
              AI-powered learning, TalentLenz for evidence-based talent
              selection, FleetCore for intelligent fleet control and Work
              Passport for workforce compliance. Or commission a custom
              system built around your operation.
            </p>

            <div className="andus-hero__actions">
              <a
                className="andus-hero__button andus-hero__button--primary"
                href="#systems"
              >
                <span>Explore our systems</span>

                <img src={arrowRightIcon} alt="" aria-hidden="true" />
              </a>

              <a
                className="andus-hero__button andus-hero__button--secondary"
                href="#custom-systems"
              >
                Build a custom system
              </a>

            </div>
          </div>

          <div className="andus-hero__visual">
            <img
              className="andus-hero__orbit"
              src={luminousOrbit}
              alt="An applied intelligence ecosystem connecting learning, talent, fleet operations and workforce compliance"
              width="2048"
              height="2048"
              loading="eager"
              fetchPriority="high"
            />

            <div
              className="andus-hero__floating-products"
              aria-hidden="true"
            >
              {products.map((product, index) => (
                <FloatingProductCard
                  key={product.name}
                  product={product}
                  index={index}
                />
              ))}
            </div>
          </div>
        </div>

        <nav
          id="systems"
          className="andus-hero__products"
          aria-label="AndUs intelligent systems"
        >
          {products.map((product) => (
            <ProductNavigationCard
              key={product.name}
              product={product}
            />
          ))}
        </nav>
      </div>
    </section>
  );
}
